// src/pages/nfl/NflPositionalData.jsx
import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import NflPosData from "./NflPosData"; // adjust if needed

const VALID = ["QB", "RB", "WR", "TE", "DST"];

export default function NflPositionalData() {
  const { pos } = useParams();

  const selected = useMemo(() => {
    const p = String(pos || "qb").toUpperCase();
    return VALID.includes(p) ? p : "QB";
  }, [pos]);

  return <NflPosData pos={selected} />;
}
